import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  icon: {
    fontSize: '20px',
    color: theme.palette.map.airport,
  },
}));

export default useStyles;
